import React from 'react'

export default function RightPaneIframe({ url }: { url: string }) {
  return (
    <div className='w-full h-full overflow-hidden'>
        <iframe 
          src={url} 
          title="Pane content"
          loading="lazy"
          className="block w-full h-full border-0"
        />
    </div>
  )
}
